import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Alert, CircularProgress, Link } from '@mui/material';
import clientApi from '../services/clientApi';
import logo from '../assets/re-stat-logo.svg';

function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('La password deve avere almeno 8 caratteri.'); return; }
    if (password !== confirm) { setError('Le password non coincidono.'); return; }
    setLoading(true);
    try {
      await clientApi.resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Errore nella reimpostazione. Il link potrebbe essere scaduto.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: 'background.default' }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 420 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box component="img" src={logo} alt="re-stat" sx={{ height: 60, mb: 1 }} />
          <Typography color="text.secondary">Reimposta la password</Typography>
        </Box>

        {!token ? (
          <Alert severity="error">Link non valido: token mancante.</Alert>
        ) : done ? (
          <Alert severity="success">Password aggiornata. Ti reindirizzo al login…</Alert>
        ) : (
          <form onSubmit={submit}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <TextField label="Nuova password" type="password" fullWidth required autoFocus margin="normal"
              value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading}
              helperText="Almeno 8 caratteri" />
            <TextField label="Conferma password" type="password" fullWidth required margin="normal"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={loading} />
            <Button type="submit" variant="contained" fullWidth size="large" sx={{ mt: 2 }} disabled={loading}
              startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}>
              {loading ? 'Salvataggio…' : 'Imposta nuova password'}
            </Button>
          </form>
        )}

        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Link component="button" type="button" variant="body2" underline="hover" onClick={() => navigate('/login')}>
            ← Torna al login
          </Link>
        </Box>
      </Paper>
    </Box>
  );
}

export default ResetPassword;
